import React, { ReactElement, FunctionComponent } from 'react'
import HeadlineFont30 from '../Theme/Fonts/Headline30'
import { BottomSheetProps } from './BottomSheetTypes'

const BottomSheet: FunctionComponent<BottomSheetProps> = ({ testID }): ReactElement => {
    return (
        <HeadlineFont30 textAlign="center" testID={testID}>
            Not yet supported on this platform
        </HeadlineFont30>
    )
}

export default BottomSheet
